import React, { useRef, useEffect } from 'react';

/**
 * WaveformDisplay component
 * Displays a live audio waveform visualization
 */
const WaveformDisplay = ({ waveformData, textColor, waveformColor = '#00ff00', width = 180, height = 80 }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const canvasWidth = canvas.width;
    const canvasHeight = canvas.height;

    // Clear canvas completely
    ctx.clearRect(0, 0, canvasWidth, canvasHeight);
    ctx.fillStyle = 'rgba(0, 0, 0, 0.3)';
    ctx.fillRect(0, 0, canvasWidth, canvasHeight);

    if (!waveformData || waveformData.length === 0) {
      // Draw flat line when no data
      ctx.strokeStyle = textColor;
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(0, canvasHeight / 2);
      ctx.lineTo(canvasWidth, canvasHeight / 2);
      ctx.stroke();
      return;
    }

    // Draw waveform
    ctx.strokeStyle = waveformColor;
    ctx.lineWidth = 2;
    ctx.beginPath();

    const sliceWidth = canvasWidth / waveformData.length;
    let x = 0;

    for (let i = 0; i < waveformData.length; i++) {
      // Normalize waveform data to canvas height
      const v = waveformData[i];
      const y = (v + 1) * canvasHeight / 2; // Convert from [-1, 1] to [0, canvasHeight]

      if (i === 0) {
        ctx.moveTo(x, y);
      } else {
        ctx.lineTo(x, y);
      }

      x += sliceWidth;
    }

    ctx.stroke();
  }, [waveformData, textColor, waveformColor]);

  return (
    <canvas
      ref={canvasRef}
      width={width}
      height={height}
      style={{
        border: `1px solid ${textColor}`,
        borderRadius: '4px',
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
      }}
    />
  );
};

export default WaveformDisplay;
